import * as React from "react";
import WarningIcon from "@images/icons/warning.svg";

interface RateWarningProps {
  children: React.ReactNode;
}

export const RateWarning = ({ children }: RateWarningProps) => {
  return (
    <div className="bg-grey border border-grey3 px-6 py-9 text-center flex flex-col items-center">
      <WarningIcon className="mb-2 w-12 h-12" />
      {children}
    </div>
  );
};
